import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output, forwardRef } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { UiIconComponent } from "../ui-icon/ui-icon.component";

let nextId = 0;

@Component({
    selector: "ui-checkbox",
    standalone: true,
    imports: [CommonModule, UiIconComponent],
    templateUrl: "./ui-checkbox.component.html",
    styleUrls: ["./ui-checkbox.component.scss"],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => UiCheckboxComponent),
            multi: true,
        },
    ],
})
export class UiCheckboxComponent implements ControlValueAccessor {
    @Input() required = false;
    // Emits the new checked state directly (unlike MatCheckbox's
    // $event.checked), for call sites that react to the toggle itself
    // rather than just binding a form control.
    @Output() checkedChange = new EventEmitter<boolean>();

    readonly id = `ui-checkbox-${nextId++}`;

    checked = false;
    disabled = false;

    private onChange: (value: boolean) => void = () => {};
    private onTouched: () => void = () => {};

    onChangeEvent(event: Event): void {
        this.checked = (event.target as HTMLInputElement).checked;
        this.onChange(this.checked);
        this.checkedChange.emit(this.checked);
    }

    onBlur(): void {
        this.onTouched();
    }

    writeValue(value: boolean | null): void {
        this.checked = !!value;
    }

    registerOnChange(fn: (value: boolean) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}
